import { createElement, Fragment } from "react";
/**
 * WordPress Dependencies
 */
// import { autop } from '@wordpress/autop';

/**
 * External Dependencies
 */
import parse from 'html-react-parser';

/**
 * Internal Dependencies
 */
import MergeTag from '../merge-tag';
const HtmlParser = ({
  value
}) => {
  if (!value) return null;
  value = value.replace(/{{([a-zA-Z0-9-_]+):([a-zA-Z0-9-_]+)}}/g, (_match, p1, p2) => {
    return `<mergetag type='${p1}' modifier='${p2}'></mergetag>`;
  });
  value = '<p>' + value.replaceAll('\n\n', '<br />') + '</p>';
  const res = createElement(Fragment, null, parse(value, {
    replace: domNode => {
      if (
      // @ts-expect-error
      domNode?.name === 'mergetag') {
        // @ts-expect-error
        const {
          modifier,
          type
        } = domNode.attribs;
        return createElement(MergeTag, {
          type: type,
          modifier: modifier
        });
      }
    }
  }));
  return createElement("div", {
    className: "renderer-core-html-parser"
  }, res, " ");
};
export default HtmlParser;
//# sourceMappingURL=index.js.map